// extracted by mini-css-extract-plugin
module.exports = {"containerCartItms":"checkout_containerCartItms__1Z_Ul","cardReciept":"checkout_cardReciept__1vwPL"};